<template>
  <div class="agree-content policy">
    <p>
      비즈톡 주식회사(이하 `회사'라 한다)는 정보주체의 자유와 권리 보호를 위해
      「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를
      처리하고 안전하게 관리하고 있습니다. 이에 「개인정보 보호법」 제30조에
      따라 정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와
      관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이
      개인정보 처리방침을 수립 ‧ 공개합니다.
    </p>
    <table>
      <tr>
        <th colspan="3">[ 주요 개인정보 처리 표시(라벨링) ]</th>
      </tr>
      <tr>
        <td>일반 개인정보 수집</td>
        <td>개인정보 처리목적</td>
        <td>개인정보의 보유 기간</td>
      </tr>
      <tr>
        <td>처리위탁</td>
        <td>개인정보 보호책임자</td>
        <td>고충처리부서</td>
      </tr>
    </table>
    <table>
      <tr>
        <th colspan="2">&#60;목차&#62;</th>
      </tr>
      <tr>
        <td>1. 개인정보의 처리 목적</td>
        <td>7. 정보주체와 법정대리인의 권리의무 및 행사방법</td>
      </tr>
      <tr>
        <td>2. 개인정보의 보유 및 이용 기간</td>
        <td>8. 개인정보의 안전성 확보조치</td>
      </tr>
      <tr>
        <td>3. 처리하는 개인정보의 항목</td>
        <td>9. 개인정보 보호책임자</td>
      </tr>
      <tr>
        <td>
          4. 개인정보의 자동 수집 장치의 설치 운영 및 거부에 관한 관한 사항
        </td>
        <td>10. 개인정보 열람청구</td>
      </tr>
      <tr>
        <td>5. 개인정보 처리업무의 위탁에 관한 사항</td>
        <td>11. 권익침해 구제방법</td>
      </tr>
      <tr>
        <td>6. 개인정보의 파기</td>
        <td>12. 개인정보 처리방침의 변경</td>
      </tr>
    </table>
    <br />
    <h3>1. 개인정보의 처리 목적</h3>
    <p>
      회사는 다음의 목적을 위하여 최소한의 개인정보를 수집하여 처리합니다.
      처리하고 있는 개인정보는 다음 목적 이외의 용도로는 이용되지 않으며, 이용
      목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를
      받는 등 필요한 조치를 이행할 예정입니다.<br />
      ① 서비스 제공 및 운영: 서비스 신청 및 승낙사항에 대한 이행, 서비스 제공에
      따른 요금정산, 콘텐츠 제작 및 제공, 부정가입 방지를 위한 본인인증, 당사의
      AGENT 모듈 또는 API 연동, 이용내역서 및 계산서 발행, 미납요금추심<br />
      ② 이용자 관리: 본인확인, 개인식별, 불량회원의 부정 이용 방지와 비인가 사용
      방지, 중복가입 확인, 이용신청 확인, 분쟁 조정을 위한 기록보전, 불만처리 등
      민원처리, 고지사항 전달, 이용자 요청에 따른 이용내역(이용정보) 제공의
      목적으로 개인정보를 처리합니다.
    </p>

    <h3>2. 개인정보의 보유 및 이용 기간</h3>
    <p>
      ① 회사는 이용자의 개인정보를 원칙적으로 개인정보의 수집 및 이용목적이
      달성되면 지체 없이 파기됩니다. 단, 다음의 정보에 대해서는 아래의 이유로
      명시한 기간 동안 보존합니다.<br />
      ② 회사 내부 방침에 의한 정보보유 사유<br />
    </p>
    <table>
      <tr>
        <th>보관사유</th>
        <th>보관정보</th>
        <th>보유기간</th>
      </tr>
      <tr>
        <td>부정 이용 방지</td>
        <td>부정이용기록</td>
        <td>1년</td>
      </tr>
      <tr>
        <td>회원식별</td>
        <td>이름, 닉네임, 이메일, 휴대전화번호, 성별, 생년월일, 주소, CI</td>
        <td>탈퇴 시 즉시 파기</td>
      </tr>
    </table>
    <p>
      ③ 상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에
      의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 동안
      회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만
      이용하며 보존기간은 아래와 같습니다.
    </p>
    <table>
      <tr>
        <th>보존근거</th>
        <th>보유항목</th>
        <th>보유기간</th>
      </tr>
      <tr>
        <td>통신비밀보호법</td>
        <td>웹사이트 방문에 관한 기록</td>
        <td>3개월</td>
      </tr>
      <tr>
        <td rowspan="3">전자상거래 등에서의 소비자보호에 관한 법률</td>
        <td>웹사이트 방문에 관한 기록</td>
        <td>3개월</td>
      </tr>
      <tr>
        <td>웹사이트 방문에 관한 기록</td>
        <td>3개월</td>
      </tr>
      <tr>
        <td>웹사이트 방문에 관한 기록</td>
        <td>3개월</td>
      </tr>
    </table>

    <h3>3. 처리하는 개인정보의 항목</h3>
    <p>
      <b>회사는 서비스의 원활한 제공에 필요한 최소한의 정보를 수집합니다.</b
      ><br />
      ① 회원 가입 및 관리, 서비스 제공<br />
      1) 이름, 닉네임, 이메일, 휴대전화번호, 성별, 생년월일, 주소, CI
    </p>

    <h3>4. 개인정보의 자동 수집 장치의 설치 운영 및 거부에 관한 관한 사항</h3>
    <p>
      이용자 개개인에게 개인화되고 맞춤화 된 서비스를 제공하기 위해서 회사는
      이용자의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.
      쿠키는 웹사이트를 운영하는데 이용되는 서버가 사용자의 브라우저에게 보내는
      조그마한 데이터 꾸러미로 이용자 컴퓨터의 하드디스크에 저장됩니다.<br />
      ① 쿠키의 사용 목적 회원과 비회원의 접속 빈도나 방문 시간 등의 분석,
      이용자의 취향과 관심분야의 파악 및 자취 추적, 각종 이벤트 참여 정도 및
      방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공<br />
      ② 쿠키 설정 거부 방법 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다.
      따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를
      허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의
      저장을 거부할 수도 있습니다.<br />
      * 설정방법 예(인터넷 익스플로러의 경우): 웹 브라우저 상단의 도구 > 인터넷
      옵션 > 개인정보(단, 쿠키 설치를 거부하였을 경우 로그인이 필요한 일부
      서비스의 이용이 어려울 수 있습니다.)
    </p>

    <h3>5. 개인정보 처리업무의 위탁에 관한 사항</h3>
    <p>
      회사는 서비스 제공을 위해 아래와 같이 개인정보 처리 업무를 외부 업체에
      위탁하여 운영하고 있습니다. 위탁계약 체결 시 개인정보보호의 안전을 기하기
      위하여 위탁계약 내용에 개인정보보호 관련 지시 엄수, 개인정보의 유출금지 및
      사고시의 책임부담 등을 명확히 규정하고 있습니다.
    </p>
    <table>
      <tr>
        <th>수탁업체</th>
        <th>업무위탁의 내용</th>
        <th>보유 및 이용기간</th>
      </tr>
      <tr>
        <td>카카오</td>
        <td>알림톡 메시지 발송</td>
        <td>위탁 계약 종료 시</td>
      </tr>
    </table>

    <h3>6. 개인정보의 파기 절차 및 방법에 관한 사항</h3>
    <p>
      회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게
      되었을 때에는 지체없이 해당 개인정보를 파기합니다.<br />
      <b> ① 파기계획 수립</b><br />
      회사는 내부 방침 및 관련 법령에 따라 개인정보 파기계획을 수립합니다.<br />
      <b>② 파기절차 및 기한</b><br />
      이용자가 입력한 정보는 보유기간이 경과했거나 처리목적이 달성된 후 지체
      없이 파기합니다.<br />
      <b>③ 파기방법</b><br />
      회사는 처리하는 개인정보를 파기할 때에는 다음의 방법으로 파기 합니다.<br />
      1) 전자적 파일 형태인 경우 : 복원이 불가능한 방법으로 영구삭제<br />
      2) 전자적 파일의 형태 외의 기록물, 인쇄물, 서면, 그 밖의 기록매체인 경우 :
      파쇄 또는 소각
    </p>

    <h3>7. 정보주체와 법정대리인의 권리의무 및 행사방법</h3>
    <p>
      <b>
        ① 정보주체는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구
        등의 권리를 행사할 수 있습니다.
      </b>
      <br />
      ※ 만 14세 미만 아동에 관한 개인정보의 열람 등 요구는 법정대리인이 직접
      해야 하며, 만 14세 이상의 미성년자인 정보주체는 정보주체의 개인정보에
      관하여 미성년자 본인이 권리를 행사하거나 법정대리인을 통하여 권리를 행사할
      수도 있습니다.
      <br />
      <b>
        ② 권리 행사는 회사에 대해 「개인정보 보호법」 시행령 제41조 제1항에 따라
        서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 회사는 이에
        대해 지체없이 조치하겠습니다.
      </b>
      <br />
      <b>
        ③ 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을
        통하여 하실 수도 있습니다. 이 경우 “개인정보 처리 방법에 관한
        고시(제2020-7호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
      </b>
      <br />
      <b>
        ④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항,
        제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.
      </b>
      <br />
      <b>
        ⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집
        대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
      </b>
      <br />
      <b>
        ⑥ 회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의
        요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를
        확인합니다.
      </b>
    </p>

    <h3>8. 개인정보의 안전성 확보조치</h3>
    <p>
      회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고
      있습니다.<br />
      <b>① 기술적인 대책</b><br />
      1) 회사는 이용자의 개인정보를 관련 법률규정 및 내부정책에 따라 보안기능을
      통해 안전하게 보호하고 있습니다.<br />
      2) 회사는 백신프로그램을 이용하여 컴퓨터 바이러스에 의한 피해를 방지하기
      위한 조치를 취하고 있습니다. 백신프로그램은 주기적으로 업데이트되며
      갑작스런 바이러스가 출현될 경우 백신이 나오는 즉시 이를 적용함으로써
      개인정보가 침해되는 것을 방지하고 있습니다.<br />
      3) 회사는 네트워크 상의 개인정보를 안전하게 전송할 수 있는 보안장치를
      채택하고 있습니다.<br />
      4) 회사는 해킹 등에 의해 이용자의 개인정보가 유출되는 것을 방지하기
      위하여, 외부로부터의 침입을 차단하는 장치를 이용하고 있으며 24시간 X 365일
      침입을 감시하고 있습니다.<br />
      <b>② 관리적인 대책</b><br />
      1) 회사는 개인정보 처리직원을 개인정보 관리업무를 수행하는 자 및 업무상
      개인정보의 처리가 불가피 한 자로 엄격히 제한하고 담당직원에 대한 수시
      교육을 통하여 개인정보처리방침의 준수를 강조하고 있습니다.
    </p>

    <h3>9. 개인정보 보호책임자</h3>
    <p>
      회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와
      관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보
      보호책임자를 지정하고 있습니다.
    </p>
    <table>
      <tr>
        <th>개인정보 <br />보호책임자</th>
        <th>개인정보 <br />보호담당자</th>
      </tr>
      <tr>
        <td>정의영</td>
        <td>백두산</td>
      </tr>
      <tr>
        <td>전화:1588-3764</td>
        <td>전화:070-8896-7359</td>
      </tr>
      <tr>
        <td colspan="2">
          이메일:
          <a href="mailto:biztalk_privacy@biztalk.co.kr"
            >biztalk_privacy@biztalk.co.kr</a
          >
        </td>
      </tr>
    </table>

    <h3>10. 개인정보 열람청구</h3>
    <p>
      ① 정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람청구를
      아래의 부서에 할 수 있습니다. 회사는 정보주체의 개인정보 열람청구가
      신속하게 처리되도록 하겠습니다.
    </p>
    <table>
      <tr>
        <th>부서명</th>
        <th>개인정보파일</th>
        <th>연락처</th>
      </tr>
      <tr>
        <td>TS사업부</td>
        <td>메시지 발송 이력</td>
        <td>
          • 전화:070-8896-7359<br />
          • 이메일:
          <a href="mailto:biztalk_privacy@biztalk.co.kr"
            >biztalk_privacy@biztalk.co.kr</a
          >
        </td>
      </tr>
    </table>

    <h3>11. 권익침해 구제방법</h3>
    <p>
      ① 정보주체는 개인정보침해로 인한 구제를 받기 위하여
      개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에
      분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의
      신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.<br />
      1. 개인정보분쟁조정위원회 : (국번없이) 1833-6972 (<a
        href="www.kopico.go.kr"
        >www.kopico.go.kr</a
      >)<br />
      2. 개인정보침해신고센터 : (국번없이) 118 (<a href="privacy.kisa.or.kr"
        >privacy.kisa.or.kr</a
      >)<br />
      3. 대검찰청 : (국번없이) 1301 (<a href="www.spo.go.kr">www.spo.go.kr</a
      >)<br />
      4. 경찰청 : (국번없이) 182 (<a href="ecrm.cyber.go.kr">ecrm.cyber.go.kr</a
      >)
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.policy {
  table {
    border-right: 1px solid var(--gray-light-2);
    margin-bottom: 1rem;
    th {
      background: #dddddd;
      border-top: 1px solid var(--gray-light-2);
      border-collapse: collapse;
    }
    th,
    td {
      border-bottom: 1px solid var(--gray-light-2);
      border-left: 1px solid var(--gray-light-2);
      padding: 0.5rem;
      text-align: center;
    }
  }
}
</style>